import { type StringOption } from './Option';

export enum DisplayMode {
    Cards = 'cards',
    Grid = 'grid',
}

const mapDisplayModeToLabel: Record<DisplayMode, string> = {
    [DisplayMode.Cards]: 'View as cards',
    [DisplayMode.Grid]: 'View as grid',
};

export const displayModeOptions: StringOption[] = Object.values(
    DisplayMode,
).map((displayMode) => ({
    value: displayMode,
    label: mapDisplayModeToLabel[displayMode],
}));
